var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"express",rawName:"v-express"}],ref:"inputs",staticClass:"inputs"},[_c('el-tree',{attrs:{"props":_vm.props,"load":_vm.loadNode,"lazy":""},on:{"node-click":_vm.handleNodeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }